import React, { useState, useEffect } from 'react';
import { Container } from '@/components/container';
import { Toolbar, ToolbarHeading } from '@/layouts/demo1/toolbar';
import { AgentChatPreview } from './agent-chat/AgentChatPreview';
import { AgentBuilderForm } from './agent-form/AgentBuilderForm';

const DEFAULT_FILL = '#FFFFFF';
const DEFAULT_STROKE = '#000000';

const STORAGE_KEY = 'agent_builder_data';

const AgentBuilderPage = () => {
  const [formData, setFormData] = useState(() => {
    const savedData = localStorage.getItem(STORAGE_KEY);
    if (savedData) {
      const parsed = JSON.parse(savedData);
      return {
        introduction: parsed.introduction || 'Introduction',
        greeting: parsed.greeting || 'Greeting'
      };
    }
    return {
      introduction: 'Introduction',
      greeting: 'Greeting'
    };
  });

  const [colors, setColors] = useState(() => {
    const savedData = localStorage.getItem(STORAGE_KEY);
    if (savedData) {
      const parsed = JSON.parse(savedData);
      return {
        fill: parsed.fill || DEFAULT_FILL,
        stroke: parsed.stroke || DEFAULT_STROKE
      };
    }
    return {
      fill: DEFAULT_FILL,
      stroke: DEFAULT_STROKE
    };
  });

  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasChanges) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasChanges]);

  const handleFormChange = (newData) => {
    setFormData(newData);
    setHasChanges(true);
  };

  const handleColorChange = (newColors) => {
    setColors(newColors);
    setHasChanges(true);
  };

  const handleSave = () => {
    const dataToSave = {
      ...formData,
      ...colors
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(dataToSave));
    setHasChanges(false);
  };

  return (
    <Container>
      <Toolbar>
        <ToolbarHeading title="Agent Builder" />
      </Toolbar>
      <div className="flex flex-col md:flex-row gap-8 mt-8 h-[calc(100vh-200px)]">
        <div className="flex-1 overflow-y-auto shadow-lg rounded-xl">
          <AgentChatPreview {...formData} {...colors} />
        </div>
        <div className="w-full md:w-[400px] overflow-y-auto shadow-lg rounded-xl">
          <AgentBuilderForm 
            onFormChange={handleFormChange} 
            initialData={formData}
            colors={colors}
            onColorChange={handleColorChange}
            onSave={handleSave}
            hasChanges={hasChanges}
          />
        </div>
      </div>
    </Container>
  );
};

export { AgentBuilderPage }; 